import { separator } from '../../constants';
import { ProductReference } from '../../core/api/api.entities';
import { ProductOption } from '../models/product-option.model';

const quantityUnitNameConversions: Record<string, string> = { kg: 'g', l: 'ml', m: 'cm' };
const quantityUnitAmountConversions: Record<string, number> = { g: 1000, ml: 1000, cm: 100 };

interface QuantityUnitName {
  name: string;
  namePlural: string;
}

interface Quantity {
  amount: number;
  unit: QuantityUnitName;
}

export function convertQuantityToSmallestUnit(quantity: Quantity): Quantity {
  if (['kg', 'l', 'm'].includes(quantity.unit.name) && quantity.amount < 1) {
    const quantityUnitName = quantityUnitNameConversions[quantity.unit.name]!;
    quantity.unit = { name: quantityUnitName, namePlural: quantityUnitName };
    quantity.amount *= quantityUnitAmountConversions[quantity.unit.name]!;
  }

  return quantity;
}

export function convertProductReferenceToProductOption(product: ProductReference): ProductOption {
  const parts = product.name.split(separator);
  return {
    ...product,
    displayName: parts[0],
    displayDetails: `${parts.slice(1).join(separator)}`,
  };
}
